import { useNavigate, useParams } from 'react-router-dom';
import {
  Button, Form, FormInstance, Row,
  Space,
} from 'antd';

import { IOfferStore, offerStore } from 'containers/Offers/Offer/store';

import { usePatchRequest, usePostRequest, useUserRole } from 'hooks';
import { getIsNew } from 'utils';

import { OfferCreate, OfferDetails, OfferUpdate } from 'codegen';
import { RecursiveRequired } from 'types';

import {
  handleOfferDetailsPatchRequest,
  handleOfferDetailsPostRequest,
  handleSuccessPatchOfferDetails,
  handleSuccessPostOfferDetails,
} from './collapseActionsHelpers';
import { PublishOfferBtn } from './PublishOfferBtn';

const { Item, useWatch } = Form;

interface ICollapseActions {
  form: FormInstance<RecursiveRequired<IOfferStore['initialValues']>>;
  isParticipation: boolean;
  isSaveBtnDisabled: boolean;
}

export const CollapseActions = ({
  form,
  isParticipation,
  isSaveBtnDisabled,
}: ICollapseActions) => {
  const initialValues = offerStore((state) => state.initialValues);

  const titleEN = useWatch(['enValues', 'title'], form);
  const titleFR = useWatch(['frValues', 'title'], form);

  const navigate = useNavigate();
  const { offerId } = useParams();

  const [postOfferDetails, { loading: postLoading }] = usePostRequest<OfferDetails, OfferCreate>({
    url: 'offers/details',
    options: {
      onSuccess: handleSuccessPostOfferDetails(navigate),
    },
  });

  const [patchOfferDetails, { loading: patchLoading }] = usePatchRequest<OfferDetails, OfferUpdate>({
    url: `offers/details/${offerId}`,
    options: {
      onSuccess: handleSuccessPatchOfferDetails,
    },
  });

  const { isAdmin } = useUserRole();

  const isNew = getIsNew(offerId);

  if (!isAdmin) {
    return null;
  }

  return (
    <Item
      noStyle
      shouldUpdate
    >
      {() => (
        <Row justify='end' className='mt-6'>
          <Space.Compact>

            <PublishOfferBtn disabled={isSaveBtnDisabled || (isParticipation && (!titleEN || !titleFR))} />

            <Button
              onClick={() => form.resetFields()}
              disabled={!form?.isFieldsTouched() || patchLoading || postLoading}
            >
              Undo
            </Button>

            <Button
              type='primary'
              loading={patchLoading || postLoading}
              disabled={
                !form?.isFieldsTouched()
                || !!isSaveBtnDisabled
                || !!form.getFieldsError().some(({ errors }) => !!errors.length)
              }
              onClick={
                isNew
                  ? handleOfferDetailsPostRequest(form, postOfferDetails)
                  : handleOfferDetailsPatchRequest(form, initialValues, patchOfferDetails)
              }
            >
              Save
            </Button>
          </Space.Compact>
        </Row>
      )}
    </Item>
  );
};
